import script from "./firstDepositPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./firstDepositPopup.vue?vue&type=script&setup=true&lang=ts"

import "./firstDepositPopup.vue?vue&type=style&index=0&id=2ac85562&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac85562"]])

export default __exports__